module.exports = __webpack_public_path__ + "static/media/item_33_9.c1d92663.png";